// @flow
import {
  applyMiddleware,
  compose,
  createStore,
} from 'redux';

/**
 * Still an issue with the latest version available at the moment of writing (v6)
 * https://github.com/rt2zz/redux-persist/issues/953#issuecomment-449545453
 */
// $FlowFixMe
import { persistStore, persistReducer } from 'redux-persist';

/**
 * Still an issue with the latest version available at the moment of writing (v6)
 * https://github.com/rt2zz/redux-persist/issues/953#issuecomment-449545453
 */
// $FlowFixMe
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { rootReducer } from '../reducers';

// eslint-disable-next-line no-underscore-dangle
const storeArgs = [];

const persistConfig = {
  key: 'root',
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

storeArgs.push(persistedReducer);

if (typeof window !== 'undefined') {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  storeArgs.push(composeEnhancers(applyMiddleware(thunk)));
}

export const store = createStore(...storeArgs);

export const persistor = persistStore(store);
